import Cookies from "universal-cookie";


const cookies = new Cookies();
export default function getCookie(cookieName) {
    return cookies.get(cookieName);
}


